import { ChatRoom, normalizeAssetUrl } from './api';

const CHAT_IMG_BASE = '/assets/templates/onelive-basic/ftv';
const LEVEL_ICON_BASE = '/assets/templates/onelive-basic/ftv/levels';

/** 原站 theme/chating/assets/img — 镜像到本地 ftv/ */
export const CHAT_LIST_REF = CHAT_IMG_BASE;

export const ENTRY_LEVEL_OPTIONS = [
  { value: '', label: '전체회원' },
  { value: 'general', label: '일반회원' },
  { value: 'silver', label: '실버회원' },
  { value: 'gold', label: '골드회원' },
  { value: 'diamond', label: '다이아몬드' },
  { value: 'vip', label: 'VIP' },
] as const;

export function entryLevelLabel(level?: string): string {
  const found = ENTRY_LEVEL_OPTIONS.find((opt) => opt.value === level);
  return found?.label ?? '일반회원';
}

export function entryLevelIcon(level?: string): string {
  const map: Record<string, string> = {
    general: `${LEVEL_ICON_BASE}/level_2.svg`,
    silver: `${LEVEL_ICON_BASE}/level_3.svg`,
    gold: `${LEVEL_ICON_BASE}/level_4.svg`,
    diamond: `${LEVEL_ICON_BASE}/level_5.svg`,
    vip: `${LEVEL_ICON_BASE}/level_6.svg`,
  };
  return map[level ?? 'general'] ?? `${LEVEL_ICON_BASE}/level_2.svg`;
}

/** 原站 입장 코인 표시 (레벨별 기본값) */
export function entryLevelCoin(level?: string): number {
  const map: Record<string, number> = {
    general: 100,
    silver: 200,
    gold: 300,
    diamond: 500,
    vip: 1000,
  };
  return map[level ?? 'general'] ?? 100;
}

export function roomCapacity(
  room: { current_occupancy?: number; max_capacity?: number; viewer_count?: number },
  fallbackMax = 2,
): { current: number; max: number } {
  const max = room.max_capacity ?? fallbackMax;
  const current = Math.min(room.current_occupancy ?? room.viewer_count ?? 0, max);
  return { current, max };
}

/** 是否可进入聊天室（以 API can_enter 为准） */
export function canEnterChatRoom(room: { can_enter?: boolean; current_occupancy?: number; max_capacity?: number }): boolean {
  if (room.can_enter === false) return false;
  if (room.can_enter === true) return true;
  const { current, max } = roomCapacity(room);
  return current < max;
}

export function chatListAsset(name: string): string {
  return `${CHAT_IMG_BASE}/${name}`;
}

export function resolveChatRoomThumb(room: {
  thumbnail?: string | null;
  host_image?: string | null;
  avatar?: string | null;
}, fallback: string): string {
  const candidate = room.thumbnail || room.host_image || room.avatar;
  return candidate ? normalizeAssetUrl(candidate) || fallback : fallback;
}

/** 진행중(상단) / 채팅방 리스트(하단) 분리 — 종료됐지만 감추지 않은 방은 하단에 표시 */
export function splitChatListRooms(
  catalogRooms: ChatRoom[],
  proceedingFromApi: ChatRoom[],
): { proceedingRooms: ChatRoom[]; rooms: ChatRoom[] } {
  const proceedingRooms = proceedingFromApi.filter(
    (room) =>
      room.is_displayed !== false &&
      room.status === 'active',
  );
  const proceedingIds = new Set(proceedingRooms.map((room) => room.id));

  const rooms: ChatRoom[] = [];
  const seen = new Set<number>();

  for (const room of catalogRooms) {
    if (room.is_displayed === false) {
      continue;
    }
    if (proceedingIds.has(room.id)) {
      continue;
    }
    if (!seen.has(room.id)) {
      rooms.push(room);
      seen.add(room.id);
    }
  }

  return { proceedingRooms, rooms };
}

export function resolveChatRoomThumbOptional(room: {
  thumbnail?: string | null;
  host_image?: string | null;
  avatar?: string | null;
}): string | null {
  const candidate = room.thumbnail || room.host_image || room.avatar;
  if (!candidate) return null;
  return normalizeAssetUrl(candidate) || null;
}
